import React, { useMemo, useState } from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { useNavigate } from 'react-router-dom'

const Section = styled('section')(({ theme }) => ({
  backgroundColor: '#0E1116',
  padding: '80px 0',
  paddingTop: '40px',
  color: '#fff',
  [theme.breakpoints.down('md')]: {
    padding: '60px 0',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '40px 0',
  },
}))

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '3rem',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '12px',
  '& span': {
    color: '#21CA50',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '2.5rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '2rem',
  },
}))

const Subtitle = styled(Typography)(({ theme }) => ({
  color: '#9AA6B2',
  fontSize: '1rem',
  textAlign: 'center',
  marginBottom: '32px',

  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
    marginBottom: '24px',
    padding: '0 16px',
  },
}))

const Columns = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '24px',
  marginTop: '32px',
  flexWrap: 'wrap',
  alignItems: 'stretch',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}))

const LeftColumn = styled(Box)(({ theme }) => ({
  flex: '1 1 600px',
  minWidth: '320px',
  [theme.breakpoints.down('md')]: {
    flex: '1 1 auto',
    width: '100%',
    minWidth: 'unset',
  },
}))

const RightColumn = styled(Box)(({ theme }) => ({
  flex: '1 1 600px',
  minWidth: '320px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  [theme.breakpoints.down('md')]: {
    flex: '1 1 auto',
    width: '100%',
    minWidth: 'unset',
  },
}))

const Card = styled(Box)(({ theme }) => ({
  backgroundColor: '#101318',
  borderRadius: '15px',
  padding: '16px',
  border: '0.5px solid rgba(36, 106, 102, 0.15)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: '0 16px 30px rgba(0,0,0,0.3)',
    border: '1px solid #246A66',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '4px',
  },
}))

const Tabs = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '16px',
  overflowX: 'auto',
  whiteSpace: 'nowrap',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
})

const Tab = styled(Box)({
  color: '#B1B5C3',
  // fontWeight: 600,
  fontSize: '0.95rem',
  padding: '8px 12px',
  borderRadius: '12px',
  backgroundColor: 'transparent',
  cursor: 'pointer',
})

const TabActive = styled(Tab)({
  color: '#fff',
  fontWeight: 500,
  // backgroundColor: 'rgba(255,255,255,0.06)',
})

const More = styled(Box)({
  marginLeft: 'auto',
  color: '#9AA6B2',
  cursor: 'pointer',
  // fontWeight: 600,
})

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '14px',
  borderRadius: '12px',
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: '#15181E',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '4px',
  },
}))

const Badge = styled(Box)(({ theme }) => ({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  fontWeight: 700,
  marginRight: '12px',
  [theme.breakpoints.down('sm')]: {
    width: '24px',
    height: '24px',
    marginRight: '8px',
    fontSize: '0.75rem',
  },
}))

const Pair = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.875rem',
  },
}))

const Price = styled(Typography)(({ theme }) => ({
  color: '#fff',
  minWidth: '100px',
  textAlign: 'right',
  [theme.breakpoints.down('sm')]: {
    minWidth: '50px',
    fontSize: '0.875rem',
  },
}))

const Change = styled(Typography)(({ color, theme }) => ({
  minWidth: '70px',
  textAlign: 'right',
  color,
  fontWeight: 500,
  [theme.breakpoints.down('sm')]: {
    minWidth: '50px',
    fontSize: '0.875rem',
  },
}))

const TradeButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '10px',
  padding: '4px 14px',
  fontWeight: 600,
  backgroundColor: '#1DA094',
  color: 'white',
  '&:hover': {
    boxShadow: '0 0 10px #1DA094',
    backgroundColor: '#1DA094',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '4px 10px',
    fontSize: '0.8rem',
    minWidth: 'auto',
    marginLeft: '8px',
  },
}))

const ViewAllButton = styled(Button)({
  marginTop: '24px',
  textTransform: 'none',
  borderRadius: '12px',
  padding: '12px 48px',
  fontSize: '1rem',
  fontWeight: 500,
  backgroundColor: 'transparent',
  color: '#fff',
  border: '1px solid #23262F',
  '&:hover': {
    backgroundColor: '#21242C',
    borderColor: '#21AB9D',
    '& .MuiSvgIcon-root': {
      transform: 'translateX(5px)',
    },
  },
  '& .MuiSvgIcon-root': {
    transition: 'transform 0.3s ease',
  },
})


const tokensRight = [
  {
    pair: 'BTCUSDT',
    price: '91,346',
    change: -1.7,
    color: '#F7931A',
    label: 'B',
  },
  {
    pair: 'ETHUSDT',
    price: '91,346',
    change: -1.7,
    color: '#627EEA',
    label: 'E',
  },
  {
    pair: 'SOLUSDT',
    price: '91,346',
    change: -1.7,
    color: '#7A52FF',
    label: 'S',
  },
  {
    pair: 'XNYUSDT',
    price: '91,346',
    change: -1.7,
    color: '#0AA37F',
    label: 'X',
  },
]

const tokensBottom = [
  {
    pair: 'BTCUSDT',
    price: '91,346',
    change: -1.7,
    color: '#F7931A',
    label: 'B',
  },
  {
    pair: 'ETHUSDT',
    price: '91,346',
    change: -1.7,
    color: '#627EEA',
    label: 'E',
  },
]

function TokenList({ items, navigate, type = 'INR' }) {
  const price = type === 'INR' ? (t) => Number(t?.price) : (t) => Number(t?.details?.last)
  const change = type === 'INR' ? (t) => Number(t?.change) : (t) => Number(t?.details?.changeRate)
  const navigationPath = type === 'INR' ? (t) => `/spot/${t?.pair}` : (t) => `/spot-usdt/${t?.details?.symbol}`
  return (
    <Box>
      {items.map((t, i) => (
        <Row key={i} sx={{ paddingY: '8px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            {/* <Badge sx={{ backgroundColor: t.color }}>{t.label}</Badge> */}
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                overflow: 'hidden',
                flex: '0 0 auto',
                mt: '-2px',
                mr: '8px',
              }}
            >
              <img
                src={t?.fromCurrency?.image}
                alt={t?.pair && t?.pair.split('_').join('/')}
                width="100%"
                height="100%"
                style={{ objectFit: 'cover' }}
              />
            </Box>
            <Pair variant='body1'>{t?.pair && t?.pair.split('_').join('/')}</Pair>
          </Box>
          <Price variant='body1'>{price(t)}</Price>
          <Change variant='body1' color={change(t) >= 0 ? '#21CA50' : '#FF5A5A'}>
            {change(t) >= 0
              ? `+${change(t).toFixed(2)}%`
              : `${change(t).toFixed(2)}%`}
          </Change>
          <TradeButton onClick={() => navigate(navigationPath(t))}>Trade</TradeButton>
        </Row>
      ))}
    </Box>
  )
}

// function CardWithTabs({ children, full }) {
//   return (
//     <Card sx={full ? { height: '100%' } : undefined}>
//       <Tabs>
//         <TabActive>Hot Futures</TabActive>
//         <Tab>Hot Tokens</Tab>
//         <Tab>Alpha</Tab>
//         <Tab>Featured</Tab>
//         <More>More {'>'}</More>
//       </Tabs>
//       {children}
//     </Card>
//   )
// }

function PendingTokens({ type }) {
  return (
    <Box
      sx={{
        height: type === 'V2USDT' ? 500 : type === 'INR' ? 282 : type === 'V2USDT2' ? 129 : 220,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#9AA6B2',
        fontSize: '0.95rem',
      }}
    >
      🚧 Pending Tokens
    </Box>
  )
}
const TAB_RANGES = {
  V2USDT: {
    hot: [0, 8],
    tokens: [8, 16],
    alpha: [16, 24],
    featured: [24, 32],
  },
  INR: {
    hot: [0, 4],
    tokens: [4, 8],
    alpha: [8, 12],
    featured: [12, 16],
  },
  DUMMY: {
    hot: [0, 2],
    tokens: [2, 4],
    alpha: [4, 6],
    featured: [6, 8],
  },
}
const customSxDummy = { mb: '0px' }
function CardWithTabs({ data = [], type, full }) {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('hot')

  const currentRange = TAB_RANGES[type] || {}
  const [start, end] = currentRange[activeTab] || [0, 0]
  const slicedData = useMemo(() => {
    return data.slice(start, end)
  }, [data, start, end])

  return (
    <Card sx={full ? { height: '100%' } : null}>
      <Tabs sx={type === 'DUMMY' ? customSxDummy : {}}>
        {['hot', 'tokens', 'alpha', 'featured'].map(t =>
          activeTab === t ? (
            <TabActive key={t}>
              {t === 'hot' && 'Hot Futures'}
              {t === 'tokens' && 'Hot Tokens'}
              {t === 'alpha' && 'Alpha'}
              {t === 'featured' && 'Featured'}
            </TabActive>
          ) : (
            <Tab key={t} onClick={() => setActiveTab(t)}>
              {t === 'hot' && 'Hot Futures'}
              {t === 'tokens' && 'Hot Tokens'}
              {t === 'alpha' && 'Alpha'}
              {t === 'featured' && 'Featured'}
            </Tab>
          )
        )}
        <More onClick={() => navigate('/markets')}>More <KeyboardArrowRightIcon /></More>
      </Tabs>

      <TokenList items={slicedData} navigate={navigate} type={type} />
    </Card>
  )
}

function MostTrendingTokens({ marketValues }) {
  const navigate = useNavigate()
  return (
    <Section>
      <div className='container'>
        <Title variant='h1'>
          Most Trending{' '}
          <span
            style={{
              display: 'inline-block',
              backgroundImage: 'linear-gradient(to right, #21AB9D, #34d399)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            Tokens
          </span>
        </Title>
        <Subtitle>Trade across 250+ Spot pairs & 350+ Futures pairs</Subtitle>
        <Columns>
          <LeftColumn>
            <CardWithTabs full type='V2USDT' data={marketValues?.V2USDT || []} navigate={navigate} />
          </LeftColumn>
          <RightColumn>
            <CardWithTabs type='INR' data={marketValues?.INR || []} navigate={navigate}>
              <Box
                sx={{
                  display: 'flex',
                  gap: '6px',
                  justifyContent: 'center',
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                  }}
                />
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: '#21CA50',
                  }}
                />
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                  }}
                />
              </Box>
            </CardWithTabs>
            <CardWithTabs type='DUMMY' data={marketValues?.V2USDT || []} navigate={navigate} />
          </RightColumn>
        </Columns>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <ViewAllButton onClick={() => navigate('/markets')}>
            View All Markets <KeyboardArrowRightIcon />
          </ViewAllButton>
        </Box>
      </div>
    </Section>
  )
}

export default MostTrendingTokens
